/* Copyright (c) 2020-present CloudIO Inc */

import { Theme, Typography } from '@mui/material';
import { makeStyles } from '@mui/styles';
import React from 'react';
import SVG from 'react-inlinesvg';
import congrads from './congrads.svg';

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    overflow: 'hidden',
    color: theme.palette.text.secondary,
    padding: 20,
  },
}));

export default function Congrads({ msg }: { msg: React.ReactNode }) {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <SVG width={200} height={200} src={congrads} />
      <Typography
        variant="subtitle2"
        sx={{ maxWidth: 400, whiteSpace: 'pre-wrap', textAlign: 'center' }}
      >
        Congratulations! {msg}
      </Typography>
    </div>
  );
}
